export default __webpack_public_path__ + "static/media/2470.bf8866bf.png";